// extracted by mini-css-extract-plugin
export default {"control":"control_control__x1RDk","button":"control_button__9Az4H"};